export const DEFAULT_DYNAMIC_LIST_ITEM_SIZE = 50

export const ITEM_RENDER_EVT = 'itemRendered'
export const SCROLL_EVT = 'scroll'

export const FORWARD = 'forward'
export const BACKWARD = 'backward'

export const AUTO_ALIGNMENT = 'auto'
export const SMART_ALIGNMENT = 'smart'
export const START_ALIGNMENT = 'start'
export const CENTERED_ALIGNMENT = 'center'
export const END_ALIGNMENT = 'end'

export const HORIZONTAL = 'horizontal'
export const VERTICAL = 'vertical'

export const LTR = 'ltr'
export const RTL = 'rtl'

export const RTL_OFFSET_NAG = 'negative'
export const RTL_OFFSET_POS_ASC = 'positive-ascending'
export const RTL_OFFSET_POS_DESC = 'positive-descending'

export const PageKey = {
  [HORIZONTAL]: 'pageX',
  [VERTICAL]: 'pageY',
}

export const ScrollbarSizeKey = {
  [HORIZONTAL]: 'height',
  [VERTICAL]: 'width',
}

export const ScrollbarDirKey = {
  [HORIZONTAL]: 'left',
  [VERTICAL]: 'top',
}

export const SCROLLBAR_MIN_SIZE = 20
